export const navigateExternally = to => {
  window.location.assign(to);
};